import React from 'react';

export function AnimatedSVG(): JSX.Element {
    return (
        <svg viewBox="100 150 320 220" width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style={{stopColor: '#8e2de2', stopOpacity: 1}} />
                    <stop offset="100%" style={{stopColor: '#ef4aa0', stopOpacity: 1}} />
                </linearGradient>
            </defs>

            <g transform="translate(44, 0)">
                <g transform="skewX(-10)">
                    <path
                        className="c-spinner__path"
                        pathLength={1}
                        d="M128,256
              C128,160 224,160 256,256
              C288,352 384,352 384,256
              C384,160 288,160 256,256
              C224,352 128,352 128,256"
                    />
                </g>
            </g>
        </svg>
    );
}
